// A last line of defence for a visitor who has refused or withdrawn consent.
//
// Switching Google's tags off stops new hits, but a GA4 runtime that is already
// in memory still flushes whatever it had queued when the page is hidden — events
// it collected while consent was granted. That flush is hard to stop from inside
// gtag, so outbound measurement requests are dropped here instead.
//
// Deliberately narrow: only Google's measurement endpoints. Fonts, maps, reCAPTCHA
// and our own API are untouched, and the block is only ever installed while the
// stored choice is a refusal.
const MEASUREMENT = /(^|\.)google-analytics\.com|googlesyndication\.com|doubleclick\.net|googleadservices\.com|google\.[a-z.]+\/(g\/collect|ccm\/|pagead\/|rmkt\/)|googletagmanager\.com\/(a|td|gtag|gtm\.js|ns\.html)/i;

let installed = false;
// The patches stay in place once added; this decides whether they drop anything,
// so a visitor who accepts after refusing is measured again without a reload.
let active = false;

function urlOf(input) {
  if (typeof input === "string") return input;
  if (input && typeof input.url === "string") return input.url;
  return "";
}

export function blockGoogleMeasurement() {
  if (typeof window === "undefined") return;
  active = true;
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (input, init) {
      if (active && MEASUREMENT.test(urlOf(input))) {
        // A 204 must have a null body, or constructing the Response throws —
        // which would surface as an exception at gtag's call site and could send
        // it looking for another transport.
        return Promise.resolve(new Response(null, { status: 204, statusText: "blocked by cookie choice" }));
      }
      return originalFetch.apply(this, arguments);
    };
  }

  const originalBeacon = navigator.sendBeacon && navigator.sendBeacon.bind(navigator);
  if (originalBeacon) {
    navigator.sendBeacon = function (url, data) {
      if (active && MEASUREMENT.test(String(url))) return true;
      return originalBeacon(url, data);
    };
  }

  const originalOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (originalOpen) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      if (active && MEASUREMENT.test(String(url))) arguments[1] = "about:blank";
      return originalOpen.apply(this, arguments);
    };
  }
}

// Consent given: let Google's requests through again.
export function allowGoogleMeasurement() {
  active = false;
}
